import { compose } from 'recompose';

import PayerView from './PayerView';

export default compose()(PayerView);
